import { cn } from "@/lib/utils";

export const LogoMark = ({ className }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn("w-9 h-9", className)}>
    <rect width="40" height="40" rx="10" fill="#0E0E12" stroke="rgba(10,10,12,0.08)" fillOpacity="0.95" />
    <path d="M10 11L20 31L30 11H23.5L20 18.5L16.5 11H10Z" fill="url(#vp_grad)" />
    <path d="M15 11L20 21L25 11H21.5L20 14L18.5 11H15Z" fill="#FF2A3B" />
    <defs>
      <linearGradient id="vp_grad" x1="10" y1="11" x2="30" y2="31" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF2A3B" />
        <stop offset="1" stopColor="#F59E0B" />
      </linearGradient>
    </defs>
  </svg>
);

const scrollToIdSafe = () => {
  if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};

export const Logo = ({ center = false }) => (
  <button
    type="button"
    data-testid="logo-link"
    onClick={() => (window.location.pathname === "/" ? scrollToIdSafe() : (window.location.href = "/"))}
    className={cn("flex items-center gap-2.5 group", center && "mx-auto")}
  >
    <LogoMark className="transition-transform duration-500 group-hover:rotate-[8deg]" />
    <span className="font-display font-extrabold tracking-tight text-lg text-gray-900">
      VERTEX<span className="text-crimson">.</span>
    </span>
  </button>
);

export default Logo;
